<template>
    <div :class="[$options.name, 'gr']" ref="project">
        <div class="col col--12 main">
            <div class="hero-project" ref="hero">
                <div class="project-hero-bg" 
                    :style="{ 
                        backgroundImage: `url('${getAssetFile(projectSelected.coverImg)}')`
                    }"
                >
                </div>
                <a 
                    v-if="!isMobileSize"
                    href="#"
                    class="scroll-down-cta"
                    v-scroll-to="'#content'"
                > 
                    <scroll-down-icon :color="themeColor"/>
                </a>
            </div>

            <div class="preview-info module hidden" id="content" :style="{ backgroundColor: lighterColor }">
                <div class="content">
                    <p 
                        class="info client heading -m"
                        :style="{ color: darkerColor }"
                    >
                        {{ projectSelected.client }}
                    </p>
                    <p class="info year content-text -s"> - {{ projectSelected.campaignYear }} - </p>
                    <p class="tech content-text -s">
                        <span
                            :key="`tech-${index}`"
                            class="tech-list" 
                            v-for="(tech, index) in projectSelected.tech" 
                        >
                            {{ tech }}{{ getSentencePunctuation(index) }}
                        </span>
                    </p>
                    <template v-if="projectSelected.url.isAvailable">
                        <a
                            class="info website"
                            target="_black"
                            rel="noreferrer noopener"
                            :style="{ color: darkerColor }"
                            :href="projectSelected.url.href"
                        > 
                            Visit Website
                        </a>
                    </template>
                </div>
            </div>

            <div class="content-wrapper">
                <div
                    v-if="projectSelected.mainAsset"
                    :class="[
                        'asset-container hidden',
                        { 
                            video: projectSelected.mainAsset && projectSelected.mainAsset.type === 'video',
                            gif: projectSelected.slug === 'punisher-cli-tool'
                        }
                    ]"
                >
                    <template v-if="projectSelected.mainAsset">
                        <template v-if="projectSelected.mainAsset.type === 'video'">
                            <div class="video-frame">
                                <iframe 
                                    width="100%"
                                    class="video lazy" 
                                    frameborder="0"
                                    :data-src="projectSelected.mainAsset.srcExt" 
                                ></iframe>
                            </div>
                        </template>
                        <img
                            v-else
                            class="lazy"
                            :alt="projectSelected.mainAsset.alt"
                            :data-src="getAssetFile(projectSelected.mainAsset.src)"
                        />
                    </template>
                </div>
                <div
                    :class="['module hidden', { spacer: paragraph.type === 'img'}]"
                    :key="`${projectSelected.name}${index}`"
                    v-for="(paragraph, index) in projectSelected.paragraphs"
                >
                    <div class="content">
                        <h3 
                            :class="[
                                'content-text', 
                                { 
                                    '-m': paragraph.type === 'text', 
                                    '-xs': paragraph.type === 'img'
                                }
                            ]" 
                            v-if="paragraph.heading"
                            v-html="paragraph.heading "
                        >
                        </h3>
                        <p 
                            class="txt" 
                            v-html="paragraph.content"
                            v-if="paragraph.type === 'text'"
                        ></p>
                        <div v-else-if="paragraph.type === 'img'" class="content-img">
                            <template v-if="paragraph.content && typeof paragraph.content !== 'string' && paragraph.content.length > 1">
                                <div 
                                    :key="`img-${index}`"
                                    :style="{ width: `calc((100% / ${paragraph.content.length}) - 1%)`}"
                                    v-for="(img, index) in paragraph.content" 
                                >
                                    <img class="lazy img" :data-src="getAssetFile(img)" />
                                </div> 
                            </template>
                            <img
                                v-else
                                class="lazy img"
                                :data-src="paragraph.content ? getAssetFile(paragraph.content) : paragraph.src"
                            />
                        </div>
                        <div v-else class="content-video">
                            <iframe class="video lazy" :data-src="paragraph.src" width="100%" frameborder="0"></iframe>
                        </div>
                    </div>
                </div>
                <div class="project-navigation hidden">
                    <router-link
                        class="url left"
                        v-if="prevProject >= 0 && projectsList[prevProject]"
                        :to="{
                            name: 'project',
                            params: { slug: projectsList[prevProject].slug }
                        }"
                    >
                        <font-awesome-icon icon="arrow-left" />
                        <span class="txt">{{ projectsList[prevProject].initials }}</span>
                    </router-link>
                    <router-link
                        class="url right"
                        v-if="nextProject && projectsList[nextProject]"
                        :to="{
                            name: 'project',
                            params: { slug: projectsList[nextProject].slug }
                        }"
                    >
                        <span class="txt">{{ projectsList[nextProject].initials }}</span>
                        <font-awesome-icon icon="arrow-right" />
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import chroma from 'chroma-js'
import { mapGetters } from 'vuex'
import LazyLoad from 'vanilla-lazyload'
import { gsap, Power2, easeOut, easeIn } from 'gsap'
// import VideoPlayer from '@/components/VideoPlayer'
import ScrollDownIcon from '@/components/ScrollDownIcon'
export default {
    name: 'project',
    data() {
        return {
            timeline: false,
            modules: false,
            windowHeight: 0,
            lazyLoadProductImg: false
        }
    },
    mounted() {
        if (!this.isMobileSize) {
            this.animateScrollDownBtn()
        }
        this.initCheckEl()
        this.checkElementInViewport()
        this.startLazyLoad()
        window.addEventListener('scroll', this.checkElementInViewport)
        this.$bus.$on(this.$bus.RESIZE_WINDOW, () => {
            this.initCheckEl()
        })
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.checkElementInViewport)
        this.lazyLoadProductImg.destroy()
    },
    computed: {
        ...mapGetters({
            bgColors: 'bgColors',
            themeColor: 'themeColor',
            homePageSections: 'getHomePageSections'
        }),
        nextProject() {
            return this.currentIndex < this.projectsList.length - 1
                ? this.currentIndex + 1
                : false
        },
        prevProject() {
            return this.currentIndex > 0 ? this.currentIndex - 1 : false
        },
        projectSelected() {
            return this.projectsList.find(
                project => project.slug === this.$route.params.slug
            )
        },
        currentIndex() {
            return this.projectsList.indexOf(this.projectSelected)
        },
        darkerColor() {
            return chroma(this.themeColor).darken()
        },
        lighterColor() {
            return chroma(this.themeColor).brighten()
        }
    },
    components: {
        // 'video-player': VideoPlayer,
        'scroll-down-icon': ScrollDownIcon
    },
    watch: {
        '$route.params.slug': function (slug) {
            this.$nextTick(() => {
                this.$refs.hero.classList.add('hidden')
                this.initCheckEl()
                this.checkElementInViewport()
            })
        }
    },
    methods: {
        destroyTimeline() {
            if (this.timeline) {
                this.timeline.kill()
                this.timeline = false
            }
        },
        getSentencePunctuation(index) {
            return  index < this.projectSelected.tech.length - 1 ? ', ' : '.'
        },
        getAssetFile(asset) {
            return require(`../assets/images/${this.projectSelected.slug}/${asset}`)
        },
        animateScrollDownBtn() {
            let tl = gsap.timeline()
            tl.fromTo(
                '.scroll-down-cta', 
                0.5, 
                { y: '-30%', ease: Power2.easeIn }, 
                { y: '0%', yoyo: true, repeat: 6, ease: Power2.easeOut }
            )
            return tl
        },
        initCheckEl() {
            let index = this.homePageSections.indexOf(this.$route.params.slug)
            this.$store.dispatch('saveThemeColor', this.bgColors[index])
            document.documentElement.style.setProperty('--bg-color', `${this.bgColors[index]}`)
            this.modules = this.$refs.project.querySelectorAll('.hidden')
            this.windowHeight = window.innerHeight
        },
        checkElementInViewport() {
            this.modules.forEach(section => {
                let positionFromTop = section.getBoundingClientRect().top

                if (positionFromTop - this.windowHeight <= 0) {
                    section.classList.add('fade-in-element')
                    section.classList.remove('hidden')
                }
            })
        },
        startLazyLoad() {
            if (!this.lazyLoadProductImg) {
                this.lazyLoadProductImg = new LazyLoad({
                    elements_selector: '.lazy'
                })
            } else {
                this.lazyLoadProductImg.update()
            }
            return this.lazyLoadProductImg
        }
    }
}
</script>
<style lang="scss" scoped>
.project {
    font-weight: lighter;
    padding-bottom: 2rem;
    .hero-project {
        width: 100%;
        height: 55vh;
        position: relative;
        @include g-state(tabletUp) {
            height: 100vh;
        }
        .project-hero-bg {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }

        .scroll-down-cta {
            left: 50%;
            bottom: 1rem;
            width: 2.5rem;
            position: absolute;
            transform: translateX(-50%);
        }
    }
    .title {
        text-align: center;
        .project-url {
            font-size: 0.8rem;
            display: inline-block;
        }
    }
    .main {
        .asset-container {
            width: 100%;
            margin: 1rem auto 2rem;
            @include g-state(tabletUp) {
                max-width: 90%;
                &.video {
                    max-width: 45rem;
                }
                &.gif {
                    max-width: 35rem;
                }
            }
            img {
                width: 100%;
            }
            .video-frame {
                width: 100%;
                position: relative;
                &::after {
                    content: '';
                    width: 100%;
                    display: block;
                    padding-bottom: 56%;
                }
                .video {
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                }
            }
        }
        .content-wrapper {
            padding: 1.5rem 0 0;
            @include g-state(tabletUp) {
                padding: 3rem 0;
            }
        }
        .module {
            width: 100%;
            &.spacer {
                margin: 1.5rem auto;
            }
            &.preview-info {
                display: flex;
                height: 45vh;
                padding: 1.6rem 0;
                text-align: center;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                @include g-state(tabletUp) {
                    padding: 3rem 0;
                }
                .content {
                    width: 90%;
                    padding: 0;
                    color: $white;
                    line-height: 1.2;
                    margin: 0 auto;
                    @include g-state(tablet) {
                        line-height: 1.5;
                    }
                    .info {
                        &.client {
                            font-weight: bold;
                            text-transform: uppercase;
                        }
                        &.year {
                            margin: 1rem auto;
                        }
                        &.website {
                            line-height: 1;
                            margin-top: 1rem;
                            font-weight: bold;
                            display: inline-block;
                            padding-bottom: 0.2rem;
                            transition: border 0.3s linear;
                            border-bottom: 2px solid transparent; 
                            &:hover {
                                border-bottom: 2px solid;
                            }
                        }
                    }
                    .tech {
                        @include g-state(tabletUp) {
                            margin: 0 auto;
                            max-width: 25rem;
                        }
                    }
                }
            }
            .content {
                margin: 1rem auto;
                padding: 0 1rem;
                @include g-state(tablet) {
                    padding: 0 2rem;
                }
                @include g-state(tabletUp) {
                    max-width: 50rem;
                }
                .content-img {
                    width: 100%;
                    display: flex;
                    margin: 2rem 0;
                    align-items: center;
                    justify-content: space-between;
                    .img {
                        width: 100%;
                    }
                }
                .content-video {
                    width: 100%;
                    margin: 2rem 0;
                    position: relative;
                    &::after {
                        content: '';
                        width: 100%;
                        display: block;
                        padding-bottom: 56%;
                    }
                    .video {
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        position: absolute;
                    }
                }
            }
        }
    }
    .project-navigation {
        width: 100%;
        display: flex;
        padding: 0 1rem;
        font-size: 0.8rem;
        align-items: center;
        margin: 2rem auto 0;
        justify-content: space-between;
        @include g-state(tablet) {
            padding: 0 2rem;
            font-size : 0.9rem;
        }
        @include g-state(tabletUp) {
            font-size: 1rem;
            margin: 4rem auto 0;
        }
        .url {
            display: flex;
            max-width: 40%;
            align-items: center;
            justify-content: center;
            &.left {
                margin: 0 auto 0 0;
                svg {
                    margin-right: 0.5rem;
                    margin-bottom: 0.2rem;
                    vertical-align: middle;
                }
            }
            &.right {
                margin: 0 0 0 auto;
                svg {
                    margin-left: 0.5rem;
                    margin-bottom: 0.2rem;
                    vertical-align: middle;
                }
            }
            .txt {
                line-height: 16px;
                transition: all 0.3s linear;
                border-bottom: 2px solid transparent;
            }
        }
    }
}
</style>
